<template>
  <div
    class="button-video-mobile"
    :class="[theme ? 'button-video-mobile--theme-' + theme : null]"
  >
    <ButtonVideo v-bind="buttonProps" />
  </div>
</template>

<script>
import ButtonVideo from '@/components/buttons/ButtonVideo.vue';

export default {
  components: { ButtonVideo },

  props: {
    theme: { type: String, default: null },
    label: { type: String, default: null },
    pic: { type: String, default: null },
    to: { type: [String, Object], default: null },
  },

  computed: {
    buttonProps() {
      const { label, pic, to } = this.$props;
      return { label, pic, to };
    },
  },
};
</script>

<style lang="stylus" scoped>
.button-video-mobile {
  padding: 20px;

  &--theme-green { background-color: $cl-green; }
  &--theme-purple { background-color: $cl-purple; }
  &--theme-orange { background-color: $cl-orange; }
}
</style>
